module.exports = __webpack_public_path__ + "img/pre.71c5ee2a.png";